export default {
    title: 'Shared Hosting',
    shared_hosting: 'Shared Hosting',
    invoice_id: 'Invoice ID',
    reg_date: 'Reg Date',
    due_date: 'Exp Date',
    server_status: 'Server Status',
    status: 'Status',
    package: 'Package',
    server_name: 'Server name',
    name_server: 'Name Servers',
    username: 'Username',
    shared_hosting_detail: 'Shared Hosting Detail',
    shared_hosting_info: 'Shared Hosting Information',
    cpanel: 'cPanel',
    action: 'Action',
    domain: 'Domain',
    shared_hosting_extend: 'Extend Shared Hosting',
    shared_hosting_package: 'Shared Hosting Package',
    payment_plan: 'Payment Plan',
    update_domain: 'Changing your main domain name',
    new_main_domain_name: 'New main domain name',
    new_main_domain_name_placeholder: 'Please enter your new domain name',
    new_main_domain_name_warning: {
        title: 'IMPORTANT! What this change means',
        text_1: {
            title: 'Duplicate Domain Names',
            content:
                'Your new main domain name should not exist in this or any other 1Byte Shared hosting account',
        },
        text_2: {
            title: 'Automatic Updates',
            content:
                'Any content and/or files, email and FTP accounts will be reassigned from your previous domain name to your new one',
        },
        text_3: {
            title: 'Manual Updates Required',
            content:
                'Any URL database references, contacts and mailing lists, SSL certificates. Softaculous App installations and their backups, however, will not be reassigned from your previous domain name to your new one. They should be updated manually',
        },
    },
    new_main_domain_error:
        'It looks like this domain name is either banned, already exists, or contains a trademark.',
    understand_and_agree: 'I understand and agree',
    auto_renew: 'Auto Renew',
    upgrade_shared_hosting: 'Upgrade Shared Hosting',
    upgrade_warning:
        'You need to pay this order within the day, otherwise the order will be deleted',
    package_name: 'Package Name',
    change_password: 'Change Shared Hosting Password',
};
